// extracted by mini-css-extract-plugin
export default {"moving":"Box_moving__+pqw4","moving2":"Box_moving2__TcmE4"};